import { Navigate, Route, Routes } from 'react-router-dom'
import AdminUsers from '../pages/adminUsers'
import CompanysRoutes from '../pages/company/routes'
import DropDownLst from '../pages/dropDownList'
import OptionGroupRoutes from '../pages/optionGroup/routes'
// import Area from '../pages/area'
// import Department from '../pages/departments'

const Setting = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="admin-users" />} />
      <Route path="admin-users" element={<AdminUsers />} />
      <Route path="companies/*" element={<CompanysRoutes />} />
      <Route path="option-group/*" element={<OptionGroupRoutes />} />
      <Route path="dropList" element={<DropDownLst />} />
    </Routes>
  )
}

export default Setting
